export default __webpack_public_path__ + "static/media/change-country-bg-desktop.f610a3a9.webp";